import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import ErrorBoundary from '../errorBoundary';
import DatePicker from "react-datepicker";
import {
  selectLoginData,
 } from '../login/loginSlice'

import {
 selectLoadingMonitorData,
 getDataAsync,
 updateStartDate,
 updateEndDate,
 } from './loadingMonitorSlice';
import styles from './loadingMonitor.module.css';
import DisplayTable from './displayTable';



export function LoadingMonitors() {

  const getData = ((requestType) => {
    console.log('requestType = ' +requestType);
    console.log('startdate next');
    dispatch(getDataAsync(jwt,requestType))
  })

  let { jwt } = useSelector(selectLoginData);
  //const [dates, setDates] = useState({displayStartDate,displayEndDate})
  
  let {startDate, endDate,  Processing }  = useSelector(selectLoadingMonitorData);
  //let {startDate, endDate,  Processing }  = {startDate:'2022-05-02', endDate:'2022-05-02', Processing:false}

 
 

  const dispatch = useDispatch();
  let requestType = '';


  return (
    <div>
      <div name='accessionValidation'><a href="/accessionValidation">accession Validator</a></div>
      <div className={styles.row}>
      
      <label  className={styles.descriptors}
          htmlFor="usestartDate">Start Date
        </label>
        <input
          id="useStartDate"
          className={styles.input}
          aria-label="startDate"
          value={startDate}
          type="Date"
          onChange={e => dispatch(updateStartDate(e.target.value))}
        >
        </input>
        <label  className={styles.descriptors}
          htmlFor="useendDate">
            End Date
        </label>
        <input
          id="userendDate"
          className={styles.input}
          aria-label="endDate"
          type="Date"
          value={endDate}
          onChange={e => dispatch(updateEndDate(e.target.value))}
        >
        </input>


      
        <button
          className={styles.loginBtn}
          aria-label="fetchDataBtn"
          onClick={() => {getData('orders')}}
        >
      Get Data
        </button>
        </div>
      <div className={styles.rowWhite}>
      {(Processing) ? <Loader 
         type="Puff"
         color="#00BFFF"
         height={100}
         width={100}
         //timeout={3000} //3 secs
      /> :   <ErrorBoundary>
               <DisplayTable /> 
             </ErrorBoundary>
      }
       </div>
     </div>
  );
}
